const messageTitle = "Carpark Management System"
const roleType = {
  CMS_ONLY: "CMS_ONLY",
  PUBLIC: "PUBLIC",
}

const seasonTypes = {
  Daily: "Daily",
  Monthly: "Monthly",
  Complimentary: "Complimentary",
  Guest: "Guest",
  "N/A": "N/A",
}

const seasonTypesArray = [
  "Daily",
  "Monthly",
  "Complimentary",
  "N/A",
];

const statusTypes = {
//  "Not-Available": "Not-Available",
//  Available: "Available",
  Approved: "Approved",
  Removed: "Removed",
//  Blacklist: "Blacklist",
  Pending: "Pending",
  Rejected: "Rejected",
  Suspended: "Suspended",
}

const seasonPasstSatusTypes = {
  "Not-Available": "Not-Available",
  Available: "Available",
  Approved: "Approved",
  Removed: "Removed",
  Blacklist: "Blacklist",
  Pending: "Pending",
  Rejected: "Rejected",
}

const guestStatusTypes = {
  // Available: "Available",
  Removed: "Removed",
  Approved: "Approved",
  Removed: "Removed",
  Pending: "Pending",
  Blacklist: "Blacklist",
}

const priceTypes = {
  minute: "minute",
  hour: "hour",
}

const guestAccessType = {
  Approved: "Approved",
  Complimentary: "Complimentary",
  Removed: "Removed",
  Pending: "Pending",
}

const vehicleTypes = {
  car: "car",
  bike: "bike",
}

const AuditTypes = [
  { title: "All", value: "" },
  { title: "User Audit Trails", value: "user" },
  { title: "Guest Audit Trails", value: "guest" },
  { title: "Role Audit Trails", value: "role" },
  { title: "Carpark Audit Trails", value: "carpark" },
  // { title: "Manual Overwrite Audit Ticket System", value: "manualoverwrite" },
  { title: "Season Audit Trails", value: "season" },
  { title: "Admin Audit Trails", value: "admin" },
  { title: "Bill Audit Trails", value: "bill" },
  { title: "PMS Audit Trails", value: "pms" },
]

const stations = [
  "Bishan",
  "Jurong",
  "Maxwell",
  "Novena",
  "Tampines",
  "Woodlands",
]

const billStatus = ["All", "Pending", "Paid", "Cancelled"]

export {
  messageTitle,
  statusTypes,
  guestStatusTypes,
  seasonTypes,
  seasonTypesArray,
  roleType,
  priceTypes,
  guestAccessType,
  AuditTypes,
  stations,
  billStatus,
  vehicleTypes,
  seasonPasstSatusTypes,
}
